import React, { useMemo } from 'react';
import InputComponent from '@ui/components/Input/Input.component';
import ModalComponent from '@ui/components/Modal/Modal.component';
import ButtonComponent from '@ui/components/Button/Button.component';
import ButtonBarComponent from '@ui/components/Button-bar/Button-bar.component';
import ModalFormComponent from '@ui/components/Modal-form/Modal-form.component';
import { IProps } from './IProps';

const Component: React.FC<IProps> = ({
    lang,
    loading,
    login,
    loginError,
    password,
    passwordError,
    passwordConfirm,
    passwordConfirmError,
    registerError,
    serverError,
    onLoginChange,
    onPasswordChange,
    onPasswordConfirmChange,
    onCreateClick,
    onInputClick,
    onKeyDown,
    onBtnKeyDown,
    onClose,
}: IProps) => {
    const alertMessage = useMemo(() => {
        if (registerError) return 'subuserRegisterError';
        else if (serverError) return 'serverError';
        else return '';
    }, []);

    return (
        <ModalComponent
            className="add-subuser"
            title="addSubuserTitle"
            alertText={alertMessage}
            lang={lang}
            loading={loading}
            onBtnKeyDown={onBtnKeyDown}
            onClose={onClose}
        >
            <ModalFormComponent>
                <InputComponent
                    label="login"
                    name="login"
                    type="text"
                    errorMessage="inputLogin"
                    lang={lang}
                    value={login}
                    error={loginError}
                    onChange={onLoginChange}
                    onClick={onInputClick}
                    onFocus={onInputClick}
                    onKeyDown={onKeyDown}
                />
                <InputComponent
                    label="password"
                    name="password"
                    type="password"
                    helperText="passwordAlertMessage"
                    errorMessage="passwordAlertMessage"
                    lang={lang}
                    value={password}
                    error={passwordError}
                    onChange={onPasswordChange}
                    onClick={onInputClick}
                    onFocus={onInputClick}
                    onKeyDown={onKeyDown}
                />
                <InputComponent
                    label="passwordConfirm"
                    name="password-confirm"
                    type="password"
                    helperText="passwordConfirmAlertMessage"
                    errorMessage="passwordConfirmAlertMessage"
                    lang={lang}
                    value={passwordConfirm}
                    error={passwordConfirmError}
                    onChange={onPasswordConfirmChange}
                    onClick={onInputClick}
                    onFocus={onInputClick}
                    onKeyDown={onKeyDown}
                />
            </ModalFormComponent>
            <ButtonBarComponent>
                <ButtonComponent
                    label="create"
                    lang={lang}
                    onClick={onCreateClick}
                    onKeyDown={onBtnKeyDown}
                />
                <ButtonComponent
                    color="error"
                    label="cancel"
                    lang={lang}
                    onClick={onClose}
                    onKeyDown={onBtnKeyDown}
                />
            </ButtonBarComponent>
        </ModalComponent>
    );
};

const AddSubuserComponent = React.memo(Component);

export default AddSubuserComponent;
